module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Regular.50d477fc.eot";